module.exports = __webpack_public_path__ + "static/media/may 2021.9e7782b0.svg";